import * as yup from 'yup';

export const userSchema = yup.object({
  firstName: yup.string().required('Required'),
  lastName: yup.string().required('Required'),
  email: yup.string().required('Required'),
  role: yup.string().required('Required'),
});
